import React from "react";
import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "../../../stylesheet/forms.css";
import { BsCheck } from "react-icons/bs";
import Topnav from "../../others/Topnav";
import InvoiceForm from "../InvoiceForm";
import BillingSummary from "../BillingSummary"
import ContextApi from "../../../context/ContextApi"
import { getSelectedBilling } from "../../../Utils/localStore";

const ServiceInvoice = () => {

  const divRef = useRef(null); // Create a reference for the Summary component's div
  const [inventoryCreated, setInventoryCreated] = useState(false);
  const [billing, setBilling] = useState(null)
  const [step, setStep] = useState(1);
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get('mode');
  const [formData, setFormData] = useState(null);
  const formContentRef = useRef(null);

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
      invoiceType: 'service'
    }));
  };

  const scrollToTop = () => {
    if (formContentRef.current) {
      formContentRef.current.scrollTo(0, 0);
    }
  };

  const handleNext = () => {
    return setStep(2)
  }

  const handlePrevious = () => {
    if (step > 1) {
      scrollToTop();
      // formData?.inventory ? setCurrentPatient(formData?.inventory?.user) : ''
      setStep(step - 1);
      localStorage.setItem("inventory", step - 1);
    }
  };

  const goto = async () => {
    await getSelectedBilling()
      .then(resp => {
        setFormData(resp[0])
      })
    if (queryParams == 'summary') {
      setStep(2)
    } else if (queryParams == 'edit') {
      setStep(1)
    }
  }

  useEffect(() => {
    if (queryParams) {
      goto()
    }
  }, []);
  
  return (
    <ContextApi.Provider
      value={{
        formData
      }}>
      <div className="new">
        <Topnav />
        <div className="form-container">
          <div className="flex justify-between w-[20%] mt-6 mb-12">
            <div className={`progress-step ${step >= 1 ? "active" : ""}`}>
              <div className={`progress-indicator`}>
                <span>{step > 1 ? <BsCheck /> : 1}</span>
              </div>
              <p className="progress-label">
                Billing
                <br />
                details
              </p>
            </div>
            <div className="progress-bar">
              <div
                className="progress-bar-inner"
                style={{ width: `${(step - 1) * 100}%` }}
              />
            </div>

            <div className={`progress-step ${step >= 2 ? "active" : ""}`}>
              <div className={`progress-indicator`}>
                <span>
                  {inventoryCreated ? <BsCheck /> : step > 1 ? <BsCheck /> : 2}
                </span>
              </div>

              <p className="progress-label">Summary</p>
            </div>
          </div>

          <form id="service_invoice1" className="form-content" ref={formContentRef}>
            {step === 1 && (
              <div className="steps">
                <h1>Create Invoice</h1>
                <InvoiceForm
                  formData={formData}
                  updateFormData={updateFormData}
                  proceed={handleNext}
                />
              </div>
            )}
            {step === 2 && (
              <div className="sum_form">
                <BillingSummary data={formData} goBack={handlePrevious} />
              </div>
            )}
          </form>
        </div>
      </div>
    </ContextApi.Provider >
  );
};

export default ServiceInvoice;
